/* eslint-disable react/require-default-props */
import React, { FC, ReactElement, useEffect, useState } from 'react'
import { withRouter, RouteComponentProps, Switch } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Grid, Button } from '@material-ui/core'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { Prospects as ProspectsStore } from '../../stores/prospects'
import Layout from '../../components/Dashboard/newLayout'
import Contacts from '../../components/Dashboard/Contacts'
import { Sender } from '../../components/types'
import UserInfo from '../../components/Dashboard/Prospects/UserInfo'
import ReadyRoom from '../../components/Dashboard/ReadyRoom'
import './styles.scss'
import ProspectGetter from '../../components/ProspectGetter'

interface MatchParams {
  email: string
}
interface Props extends RouteComponentProps<MatchParams> {
  setIsAuthenticated: (isAuthenticated: boolean) => void
  prospects?: ProspectsStore
  userEmail: string
  sender: Sender | null
}

const Admin: FC<Props> = ({ match, prospects, userEmail, sender, setIsAuthenticated }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [currentUser, setCurrentUser] = useState<any>()
  const [typeProp, setTypeProp] = useState('user')
  const [SidebarExpanded, setSidebarExpanded] = useState(false)
  let { email } = match.params
  if (!email) {
    email = ''
  }
  useEffect(() => {
    prospects?.getUserInfo()
    if (email !== '') {
      setCurrentUser({ email })
    }
  }, [])

  const [CardContent, setCardContent] = useState<ReactElement | null>(null)
  useEffect(() => {
    let content: ReactElement | null = null
    if (currentUser) {
      setSidebarExpanded(true)
      content = (
        <UserInfo
          sender={sender}
          userEmail={userEmail}
          currentUserEmail={currentUser?.email}
          setCurrentUser={setCurrentUser}
          typeProp={typeProp}
        />
      )
    } else {
      content = null
      setSidebarExpanded(false)
    }
    setCardContent(content)
  }, [prospects?.userInfoIsLoading, currentUser])

  return (
    <Layout title="Contacts" setIsAuthenticated={setIsAuthenticated}>
      <ProspectGetter />
      <div className="main-container">
        <Grid container spacing={2} className="admin-container">
          <Grid item xs={SidebarExpanded ? 9 : 12} className="admin-left">
            <ReadyRoom />
            <Contacts
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
              setTypeProp={setTypeProp}
              SidebarExpanded={SidebarExpanded}
              setSidebarExpanded={setSidebarExpanded}
            />
          </Grid>
          {SidebarExpanded && CardContent ? (
            <Grid item xs={3} className="contact-detail-card admin-right">
              <Button
                className="contact-detail-card-show-toggle"
                onClick={(): void => setSidebarExpanded(old => !old)}
              >
                <AiOutlineCloseCircle />
              </Button>
              <Switch>{CardContent}</Switch>
            </Grid>
          ) : null}
        </Grid>
      </div>
    </Layout>
  )
}

export default inject('prospects', 'search')(withRouter(observer(Admin)))
